export default __webpack_public_path__ + "static/media/mailer.f47d62ff.png";